export function failedEarly(convo: { id: string; lines: unknown[] }): boolean {
  return convo.id === 'failed' || convo.lines.length === 0;
}
